/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { InjectionToken } from '@angular/core';
import { AppProvidersConfig } from '@common/feature-core';

export const AppProvidersConfigToken = new InjectionToken<AppProvidersConfig>(
  'App Providers Config Per Deployment Environment'
);
